// export const API_URL = "http://localhost:8000/"
// export const API_URL = "https://api.lynx.allintech.io/"
// export const API_URL = "https://api.promate.allintech.io/"
export const API_URL = "https://api.excom.promatesoftware.com.au/"
// IPSFT2chV2c7          codeo pass use
// export const API_URL = "https://api.promate.codeo.com.au/"